import { FC } from 'react';
import { Box } from '@mui/material';

import useImageGroupData from '@hooks/imageHooks/useImageGroupData';

import { Hint, HintProps } from '../../base';

import ImageGroupDisplay from './Images/ImageGroupDisplay';

type ImagePreviewProps = Partial<Pick<HintProps, 'icon' | 'soft'>> & {
  shouldDisplay?: boolean;
};

const ImagePreview: FC<ImagePreviewProps> = ({ icon = 'image', soft, shouldDisplay }) => {
  const { hasContextImages, defaultImageMissing } = useImageGroupData();

  return shouldDisplay === true && hasContextImages ? (
    <Hint
      color={defaultImageMissing ? 'warning' : undefined}
      icon={icon}
      soft={soft}
      tooltip={
        <Box maxWidth={1} width={300}>
          <ImageGroupDisplay
            ContainerProps={{ py: 0.5 }}
            disableClickable
            hideMissing
            ImageCardProps={{ square: true, variant: 'elevation' }}
            minified
            previewWidth={100}
            spacing={1}
          />
        </Box>
      }
      warning={defaultImageMissing}
    />
  ) : null;
};

export default ImagePreview;
